import { render, staticRenderFns } from "./VarietySearch.vue?vue&type=template&id=2b40968a&scoped=true&"
import script from "./VarietySearch.vue?vue&type=script&lang=ts&"
export * from "./VarietySearch.vue?vue&type=script&lang=ts&"
import style0 from "./VarietySearch.vue?vue&type=style&index=0&id=2b40968a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b40968a",
  null
  
)

export default component.exports